module.exports = __webpack_public_path__ + "img/prpru-logo.bb2af85e.png";